export const countryCodes = [
  { code: '+1', country: 'United States/Canada', abbr: 'US' },
  { code: '+44', country: 'United Kingdom', abbr: 'UK' },
  { code: '+91', country: 'India', abbr: 'IN' },
  { code: '+61', country: 'Australia', abbr: 'AU' },
  { code: '+86', country: 'China', abbr: 'CN' },
  { code: '+81', country: 'Japan', abbr: 'JP' },
  { code: '+49', country: 'Germany', abbr: 'DE' },
  { code: '+33', country: 'France', abbr: 'FR' },
  { code: '+39', country: 'Italy', abbr: 'IT' },
  { code: '+34', country: 'Spain', abbr: 'ES' },
  { code: '+52', country: 'Mexico', abbr: 'MX' },
  { code: '+55', country: 'Brazil', abbr: 'BR' },
  { code: '+7', country: 'Russia', abbr: 'RU' },
  { code: '+27', country: 'South Africa', abbr: 'ZA' },
  { code: '+971', country: 'United Arab Emirates', abbr: 'UAE' },
  { code: '+92', country: 'Pakistan', abbr: 'PK' },
  { code: '+880', country: 'Bangladesh', abbr: 'BD' },
  { code: '+94', country: 'Sri Lanka', abbr: 'LK' },
  { code: '+977', country: 'Nepal', abbr: 'NP' },
  { code: '+93', country: 'Afghanistan', abbr: 'AF' },
  { code: '+98', country: 'Iran', abbr: 'IR' },
  { code: '+964', country: 'Iraq', abbr: 'IQ' },
  { code: '+966', country: 'Saudi Arabia', abbr: 'SA' },
  { code: '+972', country: 'Israel', abbr: 'IL' },
  { code: '+962', country: 'Jordan', abbr: 'JO' },
  { code: '+961', country: 'Lebanon', abbr: 'LB' },
  { code: '+90', country: 'Turkey', abbr: 'TR' },
  { code: '+20', country: 'Egypt', abbr: 'EG' },
  { code: '+234', country: 'Nigeria', abbr: 'NG' },
  { code: '+254', country: 'Kenya', abbr: 'KE' },
  { code: '+233', country: 'Ghana', abbr: 'GH' },
  { code: '+212', country: 'Morocco', abbr: 'MA' },
  { code: '+62', country: 'Indonesia', abbr: 'ID' },
  { code: '+60', country: 'Malaysia', abbr: 'MY' },
  { code: '+65', country: 'Singapore', abbr: 'SG' },
  { code: '+63', country: 'Philippines', abbr: 'PH' },
  { code: '+66', country: 'Thailand', abbr: 'TH' },
  { code: '+84', country: 'Vietnam', abbr: 'VN' },
  { code: '+82', country: 'South Korea', abbr: 'KR' },
  { code: '+31', country: 'Netherlands', abbr: 'NL' },
  { code: '+32', country: 'Belgium', abbr: 'BE' },
  { code: '+41', country: 'Switzerland', abbr: 'CH' },
  { code: '+46', country: 'Sweden', abbr: 'SE' },
  { code: '+47', country: 'Norway', abbr: 'NO' },
  { code: '+45', country: 'Denmark', abbr: 'DK' },
  { code: '+358', country: 'Finland', abbr: 'FI' },
  { code: '+48', country: 'Poland', abbr: 'PL' },
  { code: '+30', country: 'Greece', abbr: 'GR' },
  { code: '+351', country: 'Portugal', abbr: 'PT' },
  { code: '+353', country: 'Ireland', abbr: 'IE' },
  { code: '+43', country: 'Austria', abbr: 'AT' },
  { code: '+36', country: 'Hungary', abbr: 'HU' },
  { code: '+420', country: 'Czech Republic', abbr: 'CZ' },
  { code: '+64', country: 'New Zealand', abbr: 'NZ' },
  { code: '+968', country: 'Oman', abbr: 'OM' },
  { code: '+974', country: 'Qatar', abbr: 'QA' },
  { code: '+965', country: 'Kuwait', abbr: 'KW' },
  { code: '+973', country: 'Bahrain', abbr: 'BH' },
  { code: '+970', country: 'Palestine', abbr: 'PS' },
  { code: '+963', country: 'Syria', abbr: 'SY' },
  { code: '+967', country: 'Yemen', abbr: 'YE' },
  { code: '+856', country: 'Laos', abbr: 'LA' },
  { code: '+855', country: 'Cambodia', abbr: 'KH' },
  { code: '+673', country: 'Brunei', abbr: 'BN' },
  { code: '+675', country: 'Papua New Guinea', abbr: 'PG' },
  { code: '+679', country: 'Fiji', abbr: 'FJ' },
  { code: '+236', country: 'Central African Republic', abbr: 'CF' },
  { code: '+235', country: 'Chad', abbr: 'TD' },
  { code: '+228', country: 'Togo', abbr: 'TG' },
  { code: '+229', country: 'Benin', abbr: 'BJ' },
  { code: '+227', country: 'Niger', abbr: 'NE' },
  { code: '+223', country: 'Mali', abbr: 'ML' },
  { code: '+221', country: 'Senegal', abbr: 'SN' },
  { code: '+220', country: 'Gambia', abbr: 'GM' },
  { code: '+226', country: 'Burkina Faso', abbr: 'BF' },
  { code: '+225', country: 'Ivory Coast', abbr: 'CI' },
  { code: '+224', country: 'Guinea', abbr: 'GN' },
  { code: '+250', country: 'Rwanda', abbr: 'RW' },
  { code: '+257', country: 'Burundi', abbr: 'BI' },
  { code: '+252', country: 'Somalia', abbr: 'SO' },
  { code: '+211', country: 'South Sudan', abbr: 'SS' },
  { code: '+249', country: 'Sudan', abbr: 'SD' },
  { code: '+256', country: 'Uganda', abbr: 'UG' },
  { code: '+255', country: 'Tanzania', abbr: 'TZ' },
  { code: '+260', country: 'Zambia', abbr: 'ZM' },
  { code: '+263', country: 'Zimbabwe', abbr: 'ZW' },
  { code: '+265', country: 'Malawi', abbr: 'MW' },
  { code: '+258', country: 'Mozambique', abbr: 'MZ' },
  { code: '+267', country: 'Botswana', abbr: 'BW' },
  { code: '+268', country: 'Eswatini', abbr: 'SZ' },
  { code: '+264', country: 'Namibia', abbr: 'NA' },
  { code: '+232', country: 'Sierra Leone', abbr: 'SL' },
  { code: '+231', country: 'Liberia', abbr: 'LR' },
  { code: '+240', country: 'Equatorial Guinea', abbr: 'GQ' },
  { code: '+241', country: 'Gabon', abbr: 'GA' },
  { code: '+242', country: 'Congo', abbr: 'CG' },
  { code: '+243', country: 'DR Congo', abbr: 'CD' },
  { code: '+251', country: 'Ethiopia', abbr: 'ET' },
  { code: '+291', country: 'Eritrea', abbr: 'ER' },
  { code: '+385', country: 'Croatia', abbr: 'HR' },
  { code: '+386', country: 'Slovenia', abbr: 'SI' },
  { code: '+421', country: 'Slovakia', abbr: 'SK' },
  { code: '+40', country: 'Romania', abbr: 'RO' },
  { code: '+359', country: 'Bulgaria', abbr: 'BG' },
  { code: '+370', country: 'Lithuania', abbr: 'LT' },
  { code: '+372', country: 'Estonia', abbr: 'EE' },
  { code: '+371', country: 'Latvia', abbr: 'LV' },
  { code: '+381', country: 'Serbia', abbr: 'RS' },
  { code: '+382', country: 'Montenegro', abbr: 'ME' },
  { code: '+387', country: 'Bosnia and Herzegovina', abbr: 'BA' },
  { code: '+389', country: 'North Macedonia', abbr: 'MK' },
  { code: '+354', country: 'Iceland', abbr: 'IS' },
  { code: '+352', country: 'Luxembourg', abbr: 'LU' },
  { code: '+374', country: 'Armenia', abbr: 'AM' },
  { code: '+994', country: 'Azerbaijan', abbr: 'AZ' },
  { code: '+995', country: 'Georgia', abbr: 'GE' },
  { code: '+376', country: 'Andorra', abbr: 'AD' },
  { code: '+378', country: 'San Marino', abbr: 'SM' },
  { code: '+383', country: 'Kosovo', abbr: 'XK' },
  { code: '+590', country: 'Guadeloupe', abbr: 'GP' },
  { code: '+594', country: 'French Guiana', abbr: 'GF' },
  { code: '+596', country: 'Martinique', abbr: 'MQ' },
  { code: '+689', country: 'French Polynesia', abbr: 'PF' },
  { code: '+262', country: 'Reunion', abbr: 'RE' },
  { code: '+290', country: 'Saint Helena', abbr: 'SH' },
  { code: '+500', country: 'Falkland Islands', abbr: 'FK' },
  { code: '+501', country: 'Belize', abbr: 'BZ' },
  { code: '+502', country: 'Guatemala', abbr: 'GT' },
  { code: '+503', country: 'El Salvador', abbr: 'SV' },
  { code: '+504', country: 'Honduras', abbr: 'HN' },
  { code: '+505', country: 'Nicaragua', abbr: 'NI' },
  { code: '+506', country: 'Costa Rica', abbr: 'CR' },
  { code: '+507', country: 'Panama', abbr: 'PA' },
  { code: '+509', country: 'Haiti', abbr: 'HT' },
  { code: '+53', country: 'Cuba', abbr: 'CU' },
  { code: '+57', country: 'Colombia', abbr: 'CO' },
  { code: '+58', country: 'Venezuela', abbr: 'VE' },
  { code: '+591', country: 'Bolivia', abbr: 'BO' },
  { code: '+592', country: 'Guyana', abbr: 'GY' },
  { code: '+593', country: 'Ecuador', abbr: 'EC' },
  { code: '+595', country: 'Paraguay', abbr: 'PY' },
  { code: '+598', country: 'Uruguay', abbr: 'UY' },
  { code: '+51', country: 'Peru', abbr: 'PE' },
  { code: '+56', country: 'Chile', abbr: 'CL' },
  { code: '+54', country: 'Argentina', abbr: 'AR' },
  { code: '+238', country: 'Cape Verde', abbr: 'CV' },
  { code: '+245', country: 'Guinea-Bissau', abbr: 'GW' },
  { code: '+248', country: 'Seychelles', abbr: 'SC' },
  { code: '+253', country: 'Djibouti', abbr: 'DJ' },
  { code: '+269', country: 'Comoros', abbr: 'KM' },
  { code: '+670', country: 'Timor-Leste', abbr: 'TL' },
  { code: '+678', country: 'Vanuatu', abbr: 'VU' },
  { code: '+680', country: 'Palau', abbr: 'PW' },
  { code: '+682', country: 'Cook Islands', abbr: 'CK' },
  { code: '+685', country: 'Samoa', abbr: 'WS' },
  { code: '+686', country: 'Kiribati', abbr: 'KI' },
  { code: '+688', country: 'Tuvalu', abbr: 'TV' },
  { code: '+692', country: 'Marshall Islands', abbr: 'MH' },
  { code: '+691', country: 'Micronesia', abbr: 'FM' },
  { code: '+1670', country: 'Northern Mariana Islands', abbr: 'MP' },
  { code: '+1671', country: 'Guam', abbr: 'GU' },
  { code: '+1345', country: 'Cayman Islands', abbr: 'KY' },
  { code: '+1242', country: 'Bahamas', abbr: 'BS' },
  { code: '+1246', country: 'Barbados', abbr: 'BB' },
  { code: '+1264', country: 'Anguilla', abbr: 'AI' },
  { code: '+1268', country: 'Antigua and Barbuda', abbr: 'AG' },
  { code: '+1284', country: 'British Virgin Islands', abbr: 'VG' },
  { code: '+1340', country: 'US Virgin Islands', abbr: 'VI' },
  { code: '+1441', country: 'Bermuda', abbr: 'BM' },
  { code: '+1473', country: 'Grenada', abbr: 'GD' },
  { code: '+1649', country: 'Turks and Caicos', abbr: 'TC' },
  { code: '+1664', country: 'Montserrat', abbr: 'MS' },
  { code: '+1758', country: 'Saint Lucia', abbr: 'LC' },
  { code: '+1767', country: 'Dominica', abbr: 'DM' },
  { code: '+1784', country: 'Saint Vincent', abbr: 'VC' },
  { code: '+1809', country: 'Dominican Republic', abbr: 'DO' },
  { code: '+1868', country: 'Trinidad and Tobago', abbr: 'TT' },
  { code: '+1869', country: 'Saint Kitts and Nevis', abbr: 'KN' },
  { code: '+1876', country: 'Jamaica', abbr: 'JM' },
  { code: '+992', country: 'Tajikistan', abbr: 'TJ' },
  { code: '+993', country: 'Turkmenistan', abbr: 'TM' },
  { code: '+996', country: 'Kyrgyzstan', abbr: 'KG' },
  { code: '+998', country: 'Uzbekistan', abbr: 'UZ' },
  { code: '+852', country: 'Hong Kong', abbr: 'HK' },
  { code: '+853', country: 'Macao', abbr: 'MO' },
  { code: '+886', country: 'Taiwan', abbr: 'TW' },
  { code: '+960', country: 'Maldives', abbr: 'MV' },
  { code: '+355', country: 'Albania', abbr: 'AL' },
  { code: '+380', country: 'Ukraine', abbr: 'UA' },
  { code: '+375', country: 'Belarus', abbr: 'BY' }
];
